import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IMessageTemplate } from '../../api/messageTemplates'
import { SearchBar } from '../SearchBar/SearchBar'

import styles from './MessageTemplateList.module.scss'

interface IMessageTemplateListProps {
    messageTemplates: IMessageTemplate[]
    selectedMessageTemplate: IMessageTemplate | null
    onSelectMessageTemplate: (messageTemplate: IMessageTemplate | null) => void
}

export const MessageTemplateList = (props: IMessageTemplateListProps) => {
    const {
        messageTemplates,
        selectedMessageTemplate,
        onSelectMessageTemplate,
    } = props
    const { t } = useTranslation()

    const [searchTerm, setSearchTerm] = useState('')

    const filteredItems = messageTemplates.filter((template) =>
        template.key.toLowerCase().includes(searchTerm.toLowerCase())
    )

    const handleSearchTermChange = (searchTerm: string) => {
        setSearchTerm(searchTerm)
        onSelectMessageTemplate(null)
    }

    return (
        <div className={styles.messageTemplateList}>
            <div className={styles.messageTemplateList__header}>
                <h2>{t('key')}</h2>
            </div>

            <div className={styles.messageTemplateList__body}>
                <SearchBar
                    value={searchTerm}
                    onChange={handleSearchTermChange}
                />

                <p className={styles.messageTemplateList__resultsCount}>
                    {filteredItems.length} results
                </p>

                {filteredItems.map((messageTemplate) => (
                    <div
                        key={messageTemplate.id}
                        className={
                            messageTemplate.id === selectedMessageTemplate?.id
                                ? styles.active
                                : ''
                        }
                    >
                        <div className={styles.messageTemplateList__row}>
                            <div
                                className={
                                    styles.messageTemplateList__row__text
                                }
                                onClick={() =>
                                    onSelectMessageTemplate(messageTemplate)
                                }
                            >
                                {messageTemplate.key}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
